<template>
    <svg
        v-if="supplierId && viewBox"
        class="nc-platform-icon"
        width="14"
        height="14"
        :viewBox="viewBox"
        aria-hidden="true"
    >
        <!-- WhatsApp -->
        <path
            v-if="supplierId === 'whatsapp'"
            fill="#25D366"
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M10 0C4.477 0 0 4.477 0 10C0 11.89 0.525 13.66 1.438 15.168L0.546 18.2C0.494785 18.3741 0.491415 18.5588 0.536244 18.7346C0.581074 18.9104 0.672448 19.0709 0.800759 19.1992C0.929071 19.3276 1.08958 19.4189 1.26542 19.4638C1.44125 19.5086 1.62592 19.5052 1.8 19.454L4.832 18.562C6.39068 19.5051 8.17822 20.0025 10 20C15.523 20 20 15.523 20 10C20 4.477 15.523 0 10 0ZM7.738 12.263C9.761 14.285 11.692 14.552 12.374 14.577C13.411 14.615 14.421 13.823 14.814 12.904C14.8636 12.7897 14.8816 12.6641 14.8661 12.5405C14.8507 12.4168 14.8023 12.2996 14.726 12.201C14.178 11.501 13.437 10.998 12.713 10.498C12.5618 10.3935 12.3761 10.3516 12.1947 10.381C12.0133 10.4105 11.8503 10.509 11.74 10.656L11.14 11.571C11.1085 11.6202 11.0593 11.6555 11.0026 11.6696C10.9459 11.6837 10.8859 11.6756 10.835 11.647C10.428 11.414 9.835 11.018 9.409 10.592C8.983 10.166 8.611 9.6 8.402 9.219C8.37609 9.1706 8.3686 9.11444 8.38091 9.06093C8.39323 9.00743 8.42453 8.9602 8.469 8.928L9.393 8.242C9.52487 8.12734 9.60996 7.9682 9.63209 7.79486C9.65422 7.62153 9.61183 7.44611 9.513 7.302C9.065 6.646 8.543 5.812 7.786 5.259C7.68831 5.1882 7.57386 5.14406 7.45393 5.13091C7.334 5.11776 7.21271 5.13606 7.102 5.184C6.182 5.578 5.386 6.588 5.424 7.627C5.449 8.309 5.716 10.24 7.738 12.263Z"
        />

        <!-- Telegram -->
        <path
            v-else-if="supplierId === 'telegram' || supplierId === 'telegram_native'"
            fill="#2CA5E0"
            d="M10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 10 0ZM14.64 6.8C14.49 8.38 13.84 12.22 13.51 13.99C13.37 14.74 13.09 14.99 12.83 15.02C12.25 15.07 11.81 14.64 11.25 14.27C10.37 13.69 9.87 13.33 9.02 12.77C8.03 12.12 8.67 11.76 9.24 11.18C9.39 11.03 11.95 8.7 12 8.49C12.0069 8.45819 12.006 8.42517 11.9973 8.3938C11.9886 8.36244 11.9724 8.33367 11.95 8.31C11.89 8.26 11.81 8.28 11.74 8.29C11.65 8.31 10.25 9.24 7.52 11.08C7.12 11.35 6.76 11.49 6.44 11.48C6.08 11.47 5.4 11.28 4.89 11.11C4.26 10.91 3.77 10.8 3.81 10.45C3.83 10.27 4.08 10.09 4.55 9.9C7.47 8.63 9.41 7.79 10.38 7.39C13.16 6.23 13.73 6.03 14.11 6.03C14.19 6.03 14.38 6.05 14.5 6.15C14.6 6.23 14.63 6.34 14.64 6.42C14.63 6.48 14.65 6.66 14.64 6.8Z"
        />

        <!-- Instagram -->
        <template v-else-if="supplierId === 'instagram'">
            <path
                fill="#E1306C"
                d="M7.8 2h8.4C19.4 2 22 4.6 22 7.8v8.4a5.8 5.8 0 0 1-5.8 5.8H7.8C4.6 22 2 19.4 2 16.2V7.8A5.8 5.8 0 0 1 7.8 2zm-.2 2A3.6 3.6 0 0 0 4 7.6v8.8C4 18.39 5.61 20 7.6 20h8.8a3.6 3.6 0 0 0 3.6-3.6V7.6C20 5.61 18.39 4 16.4 4z"
            />
            <circle fill="#E1306C" cx="17.25" cy="6.75" r="1.25" />
            <circle fill="none" stroke="#E1306C" stroke-width="2" cx="12" cy="12" r="3" />
        </template>

        <!-- TikTok -->
        <path
            v-else-if="supplierId === 'tiktok'"
            fill="#010101"
            d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-2.88 2.5 2.89 2.89 0 0 1-2.89-2.89 2.89 2.89 0 0 1 2.89-2.89c.28 0 .54.04.79.1V9.01a6.27 6.27 0 0 0-.79-.05 6.34 6.34 0 0 0-6.34 6.34 6.34 6.34 0 0 0 6.34 6.34 6.34 6.34 0 0 0 6.33-6.34V8.72a8.18 8.18 0 0 0 4.78 1.52V6.78a4.85 4.85 0 0 1-1.01-.09z"
        />

        <!-- Site (globe) -->
        <path
            v-else-if="supplierId === 'site'"
            fill="#6B7280"
            d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 17.93c-3.95-.49-7-3.85-7-7.93 0-.62.08-1.21.21-1.79L9 15v1c0 1.1.9 2 2 2v1.93zm6.9-2.54c-.26-.81-1-1.39-1.9-1.39h-1v-3c0-.55-.45-1-1-1H8v-2h2c.55 0 1-.45 1-1V7h2c1.1 0 2-.9 2-2v-.41c2.93 1.19 5 4.06 5 7.41 0 2.08-.8 3.97-2.1 5.39z"
        />

        <!-- Application (chat bubble) -->
        <path
            v-else-if="supplierId === 'application'"
            fill="#6C4FC8"
            d="M20 2H4c-1.1 0-2 .9-2 2v18l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2z"
        />
    </svg>
</template>

<script>
const VIEWBOX_20 = '0 0 20 20'
const VIEWBOX_24 = '0 0 24 24'

const VIEWBOXES = {
    whatsapp:        VIEWBOX_20,
    telegram:        VIEWBOX_20,
    telegram_native: VIEWBOX_20,
    instagram:       VIEWBOX_24,
    tiktok:          VIEWBOX_24,
    site:            VIEWBOX_24,
    application:     VIEWBOX_24,
}

export default {
    name: 'NewChatPlatformIcon',

    props: {
        supplierId: {
            type:    String,
            default: null,
        },
    },

    computed: {
        viewBox() {
            return VIEWBOXES[this.supplierId] || null
        },
    },
}
</script>

<style lang="scss">
.nc-platform-icon {
    display: block;
    flex: 0 0 auto;
}
</style>
